"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsViewHeader = void 0;
const React = require("react");
const react_1 = require("react");
const RetailLocationsContext_1 = require("../../../contexts/RetailLocationsContext");
const AppScreen_1 = require("../../../../../../components/base/atoms/AppScreen");
const PendingCustomerSalesOrders_1 = require("../../../atoms/PendingCustomerSalesOrders");
const OrderDetailsHeaderSection_1 = require("../OrderDetailsHeaderSection");
const ExtraInfoHeaderSection_1 = require("../ExtraInfoHeaderSection");
const ProductCategoriesTabPanel_1 = require("../ProductCategoriesTabPanel");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ProductsViewHeader");
const ProductsViewHeader = ({ categories }) => {
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    if (!retailLocation) {
        return null;
    }
    return (React.createElement(AppScreen_1.AppScreenHeader, null,
        React.createElement(PendingCustomerSalesOrders_1.PendingCustomerSalesOrders, null),
        React.createElement("div", { className: css(""), style: {
                backgroundImage: `url("${retailLocation.locationImageUrl}")`
            } },
            React.createElement("div", { className: css("header") },
                React.createElement(OrderDetailsHeaderSection_1.OrderDetailsHeaderSection, null),
                React.createElement(ExtraInfoHeaderSection_1.ExtraInfoHeaderSection, null))),
        categories !== null && (React.createElement(ProductCategoriesTabPanel_1.ProductCategoriesTabPanel, { categories: categories }))));
};
exports.ProductsViewHeader = ProductsViewHeader;
//# sourceMappingURL=index.js.map